// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1AiWK","inputWrap":"Table_inputWrap__1GfxW","col":"Table_col__1jufx","bmiTooltip":"Table_bmiTooltip__3KZJg"};